<div class="screen__wrapper">

<div class="app__wrapper">
  <ms-spinner-overlay *ngIf="isSpinnerShown"/>

  <mat-progress-bar mode="query" *ngIf="progressBarShow"></mat-progress-bar>

  <router-outlet></router-outlet>

  <div [ngStyle]="{ display: diploma ? 'none' : 'block' }" class="dialogs">
    <ng-container #dialogs></ng-container>
  </div>
  <button *ngIf="showPromptButton" class="add-home" (click)="addToHomeScreen()">
    {{ 'app.addToHomeScreen' | translate }}
  </button>

  <button *ngIf="showPromptButton" class="not-now" (click)="notAddToHomeScreen()">
    {{ 'app.notNow' | translate }}
  </button>

  <div *ngIf="showCookieConsentBanner" class="cookie-consent-banner">
    <div class="cookie-consent-banner__content">
      <div class="cookie-consent-banner__title">
        {{ 'cookieConsent.title' | translate }}
      </div>
      <div class="cookie-consent-banner__text">
        {{ 'cookieConsent.text' | translate }}
      </div>
      <div class="cookie-consent-banner__actions">
        <button type="button" class="cookie-consent-banner__accept" (click)="acceptCookieConsent()">
          {{ 'v3.cookieConsent.accept' | translate }}
        </button>
        <button type="button" class="cookie-consent-banner__necessary" (click)="keepNecessaryCookies()">
          {{ 'cookieConsent.necessaryOnly' | translate }}
        </button>
        <a href="" class="cookie-consent-banner__details" (click)="openCookieDetails($event)">
          {{ 'cookieConsent.details' | translate }}
        </a>
      </div>
    </div>
  </div>

</div>

<div class="layout__wrapper">
  <ms-calculator-layout />
</div>

<ms-snow-animation [enabled]="showSnow" [snowflakeCount]="100" speed="slow"></ms-snow-animation>

</div>
